import NewsInfo from "../NewsInfo";
import img1 from "../../../assets/images/index/news/20250513.jpg";

const News4 = () => {
  const title = "花蓮縣身心障礙者臨時及短期服務";
  const date = "May. 13,2025";
  const content = `服務目的：協助家庭照顧者在短期內獲得休息或處理緊急事務，避免照顧壓力過大，並提供身心障礙者安全、適切的照顧環境。
歡迎有需求的打電話來諮詢~~
我們會派專業社工師去家裡訪視！！`;

  return NewsInfo(title, date, content, img1);
};

export default News4;
